import TribesRoute from './TribesRoute'

export default TribesRoute